<div class="overflow-x-auto">
    
    <table class="w-full table-fixed min-w-[1200px] ">
        <thead>
            <!-- This row sets the widths of the columns -->
            <tr>
                <th class="w-[7.5%]"></th>
                <th class="w-[30%]"></th>
                <th class="w-[7.5%]"></th>
                <th class="w-40%"></th>
                <th class="w-20%"></th>
            </tr>
            <tr>
                <th colspan="3" class="w-[40%] p-2  border border-surface bg-emphasis">
                    {{kpiData().name}}, {{kpiData().title}}
    
                </th>
                <th colspan="5" class="w-[40%] border border-surface bg-highlight">
                    Scoring Rubric
                </th>
                <th class="w-[20%] border border-surface bg-highlight-emphasis">
                    Results
                </th>
            </tr>
            <tr>
                <th colspan="9" class="border border-surface h-2"></th>
            </tr>
            <tr>
                <th class="bg-emphasis w-[15%] border-l">Area of Focus</th>
                <th class="bg-emphasis w-[70%]">Specific Measurements (KPIs)</th>
                <th class="bg-emphasis w-[15%] border-r">Goal</th>
                <th class="bg-highlight">
                    <div class="flex flex-col items-center">
                        <span>Unacceptable</span>
                        <span>1</span>
                    </div>
                </th>
                <th class="bg-highlight">
                    <div class="flex flex-col items-center">
                        <span>Needs Improvement</span>
                        <span>2</span>
                    </div>
                </th>
                <th class="bg-highlight">
                    <div class="flex flex-col items-center">
                        <span>Goal Reached</span>
                        <span>3</span>
                    </div>
                </th>
                <th class="bg-highlight">
                    <div class="flex flex-col items-center">
                        <span>Exceeds Requirements</span>
                        <span>4</span>
                    </div>
                </th>
                <th class="bg-highlight">
                    <div class="flex flex-col items-center">
                        <span>Outstanding</span>
                        <span>5</span>
                    </div>
                </th>
                <th class="bg-highlight-emphasis border-r border-l">
                    Current Results
                </th>
            </tr>
    
        </thead>
        <tbody>
    
            @for (kpi of sortedKpiData(); track kpi.kpi; let i = $index, first = $first, last = $last) {
    
            <tr>
                @let newArea = first || kpi.area !== sortedKpiData()[i - 1].area;
                @if(newArea) {
                 <th [class.border-t-3]="newArea" class="border border-surface bg-emphasis"[attr.rowspan]="areaRowCount().get(kpi.area)">
                    <div class="flex flex-col"><span>{{kpi.area}}</span>
                    @if($any(kpi)?.data?.locationNames) {
                        @for(location of $any(kpi)?.data?.locationNames; track location;let last=$last) {
                            <span class="text-xs">{{location}}@if(!last){, }</span>
                        }
                    }
                    </div>
                </th>
                }
    
                <td [class.border-t-3]="newArea" class="border border-surface bg-emphasis w-auto">{{kpi.description}}</td>
                <td [class.border-t-3]="newArea" class="border border-surface bg-emphasis">
                    @if(kpi.tbd) {
                    <div class="text-center w-full">TBD</div>
                    }
                    @else {
                    <div class="w-full text-center">{{kpi?.data?.goal}}</div>
                    }
                </td>
                @if(kpi.tbd) {
                <td [class.border-t-3]="newArea" colspan="5" class="border border-surface bg-highlight">
                    <div class="text-center w-full">TBD</div>
                </td>
                }
                @else if (kpi.area === 'Review') {
                    <td [class.border-t-3]="newArea" colspan="5" class="border border-surface bg-highlight" [innerHTML]="kpi.comments"></td>
    
                }
                @else {
                @if(kpi.data) {
                <td [class.border-t-3]="newArea" class="border-l border-t border-b border-surface bg-highlight text-center">
                    {{kpi | kpiReportScoreRange: 1}}
    
                </td>
                <td [class.border-t-3]="newArea" class="border-t border-b bg-highlight border-surface text-center">
                    {{kpi | kpiReportScoreRange: 2}}
                </td>
                <td [class.border-t-3]="newArea" class="border-t border-b bg-highlight border-surface text-center">
                    {{kpi | kpiReportScoreRange: 3}}
                </td>
                <td [class.border-t-3]="newArea" class="border-t border-b bg-highlight border-surface text-center">
                    {{kpi | kpiReportScoreRange: 4}}
                </td>
                <td [class.border-t-3]="newArea" class="border-t border-b border-r border-surface bg-highlight text-center">
                    {{kpi | kpiReportScoreRange: 5}}
                </td>
                }
                }
    
                <td [class.border-t-3]="newArea" class="border border-surface bg-highlight-emphasis">
                    @if(kpi.tbd) {
                    <div class="text-center w-full">TBD</div>
                    }
                    @else if (kpi.data?.total === null && (kpi.value === null || kpi.value === 0)) {
                    <div class="text-center w-full">N/A</div>
                    }
                    @else if (kpi.area === 'Review') {
                        <div class="text-center w-full">{{kpi.value}}</div>
                    }
                    @else {
                    <div class="flex flex-col items-center">
    
                        @switch (kpi.kpi) {
                        @case ('recruitingCalls') {
                        <span>Calls: {{$any(kpi)?.data?.calls}}</span>
                        <span>Meetings: {{$any(kpi)?.data?.meetings}}</span>
                        <span>Total: {{kpi?.data?.total}}</span>
                        }
                        @case ('locationRetention') {
                        <span>Total: {{kpi?.data?.total}}%</span>
                        <span>({{$any(kpi)?.data?.attendees}} of {{$any(kpi)?.data?.attendeesOriginal}})</span>
    
                        }
                        @case ('locationRenewalRate') {
                        <span>Total: {{kpi?.data?.total}}%</span>
                        <span>({{$any(kpi)?.data?.renewalCount}} of {{$any(kpi)?.data?.customerCount}})</span>
    
    
                        }
                        @case ('tlRenewalRate') {
                            <span>Total: {{kpi?.data?.total}}%</span>
                            <span>({{$any(kpi)?.data?.renewalCount}} of {{$any(kpi)?.data?.customerCount}})</span>
        
                        }
                        @case ('tlExpenseReports') {
                            <span>{{kpi?.data?.total}} days</span>
                            <span>{{$any(kpi)?.data?.completeReports}} complete</span>
                            <span>{{$any(kpi)?.data?.incompleteReports}} incomplete</span>
    
    
                        }
                        @case('tlBudgets') {
                            <span>{{kpi?.data?.total}}%</span>
                            <span>{{$any(kpi)?.data?.completeReports}} complete</span>
                            <span>{{$any(kpi)?.data?.incompleteReports}} incomplete</span>
    
                        }
                        @case('locationBudgets') {
                            <span>{{kpi?.data?.total}}%</span>
                            <span>{{$any(kpi)?.data?.completeReports}} complete</span>
                            <span>{{$any(kpi)?.data?.incompleteReports}} incomplete</span>
                        }
                        @case ('consultingCapstone') {
                            <span>{{kpi?.data?.total}}%</span>    
                        }
                        @case ('locationPartnerCommunication') {
                            <span>{{kpi?.data?.total}}%</span>    
                            <a [href]="kpiData().partnerCareReportUrl" target="_blank"><fa-icon [icon]="icons.ppmSolid.externalLink"></fa-icon></a>
                        }
                        @case ('locationDonorCare') {
                            <span>{{kpi?.data?.total}}%</span>    
                            <a [href]="kpiData().donorCareReportUrl" target="_blank"><fa-icon [icon]="icons.ppmSolid.externalLink"></fa-icon></a>
                        }
                        @default {
                        <span>{{kpi?.data?.total}}</span>
                        }
                        }
    
    
                        <span class="italic">Score: {{kpi?.data?.score}}</span>
                        @if(kpi.notes) {
                        <span class="italic">{{kpi.notes}}</span>
                        }
                    </div>
                    }
                </td>
            </tr>
    
            }
            <tr>
                <td colspan="3" class="border border-surface text-center">
                    @if(kpiData().jobDescription) {
                    <a href="{{kpiData().jobDescription}}" target="_blank">{{kpiData().title}} Job Description</a>
                    }
                </td>
                <td colspan="5" class="border border-surface text-center">
                    <a href="https://docs.google.com/document/d/1wOzXXvvKsd7P7cmj5mt-Z7idGGTWcleRE4GNdOD-9Hg/edit?tab=t.0#heading=h.h3tx0rtfkutr" target="_blank">KPI Clarity Document</a>
                </td>
                <td class="border border-surface">
                    <div class="text-center w-full">
                        @if(kpiData().totalScore) {
                        {{kpiData().totalScore}}
                        }
                        @else {
                        <div class="text-center w-full">N/A</div>
                        }
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>